import { atom } from 'recoil';

const stateFilterAminoacidChange = atom({
  key: 'filter.aminoacidChange',
  default: null as string | null,
});

export default stateFilterAminoacidChange;
